import { RestResource } from "./common"
import { SchemaDeSerBuilder, type SchemaDeSer } from "./deser"

export class EventCategoryGroup extends RestResource {
  name = ""
  title = ""
  titleShort = ""
  subtitle = ""
  underlyingSymbol = ""
  underlyingInstrumentType = ""
}

export const EVENT_CATEGORY_GROUP_DESER: SchemaDeSer<EventCategoryGroup> =
  new SchemaDeSerBuilder(EventCategoryGroup)
    .ofString("name")
    .ofString("title")
    .ofString("titleShort", "title-short")
    .ofString("subtitle")
    .ofString("underlyingSymbol", "underlying-symbol")
    .ofString("underlyingInstrumentType", "underlying-instrument-type")
    .toDeSer()
